<template>
  <div>
    <v-snackbar
      v-for="(notify, index) in notifies.filter((s) => s.show)"
      v-model="notify.show"
      :key="notify.call + Math.random()"
      :timeout="180000"
      :style="`padding-bottom: ${index * 100 + 8}px;`"
      right
    >
      <p
        v-if="notify.customer"
        class="pointer"
        @click="
          customerForm = false;
          customer = null;
          notify.show = false;
          newCustomerPhoneNumber = null;
          customerForm = true;
          customer = notify.customer;
        "
      >
        <u>{{ notify.customer.full_name }}</u>&nbsp;Карточка клиента
      </p>
      <p
          v-if="notify.customer"
          class="pointer"
          @click="createBid(notify)
        "
      >
        <u>Создать заявку клиенту</u>
      </p>
      <p v-else class="pointer" @click="createBid(notify)">
        {{ $t("viewBids.add_bid") }}
      </p>
      <p>
        <v-icon x-small>fa-phone</v-icon>
        {{ notify.phone }}
      </p>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          @click="notify.show = false"
          v-bind="attrs"
          fab
          x-small
        >
          <v-icon x-small>fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="customerForm" scrollable max-width="890">
      <customerForm
        @removed="customerForm=false"
        :is-visible="customerForm"
        @store="
          (data) => {
            this.customerEditForm = false;
          }
        "
        :customer-id="customer && customer.id"
        :new-customer-phone-number="newCustomerPhoneNumber"
      ></customerForm>
    </v-dialog>
    <bid-window
      :show="bidWin.isVisible"
      @hide="bidWin.isVisible = false"
      :customer="customer"
      :bid="null"
      :new-customer-phone-number="newCustomerPhoneNumber"
    ></bid-window>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomerForm from "@/components/customer/CustomerForm";
import BidWindow from "@/components/bid/BidWindow";

export default {
  name: "NewCallNotify",
  components: { BidWindow, CustomerForm },
  data: () => ({
    bidWin: {
      isVisible: false,
    },
    customerForm: false,
    customer: null,
    newCustomerPhoneNumber: null,
  }),
  computed: {
    ...mapState("telephonies", ["notifies"]),
  },
  methods: {
    createBid(notify) {
      this.bidWin.isVisible = true;
      if (notify.customer){
        this.customer = notify.customer
      }
      this.newCustomerPhoneNumber=notify.phone;
      notify.show = false
    },
  },
};
</script>

<style scoped></style>
